module.exports = __webpack_public_path__ + "media/images/how_it_works_1-a677861a8ea45507af673b9d272f8b87.png";